import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Container } from '@mui/material';

import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import HomePage from './pages/HomePage';
import PetitionDetailPage from './pages/PetitionDetailPage';
import SubmitPetition from './pages/SubmitPetition';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import CreatePetition from './pages/CreatePetition';
import ProtectedRoute from './components/Auth/ProtectedRoute';

function App() {
  return (
    <div className="App">
      <Header />
      <main style={{ minHeight: 'calc(100vh - 200px)' }}>
        <Routes>
          {/* Rute publice */}
          <Route path="/" element={<HomePage />} />
          <Route path="/petitie/:id" element={<PetitionDetailPage />} />
          <Route path="/creaza-petitie" element={<SubmitPetition />} />
          
          {/* Autentificare admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          
          {/* Rute protejate admin */}
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/create" element={
            <ProtectedRoute>
              <CreatePetition />
            </ProtectedRoute>
          } />
          <Route path="/admin/edit/:id" element={
            <ProtectedRoute>
              <CreatePetition />
            </ProtectedRoute>
          } />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
